import type { DaySoldCardProps } from './types'
import { CardTitle, ValueWrapper, StickyBottomWrapper } from '../common/styles'
import { DaySoldCardContainer } from './styles'
import { ProgressRow } from '../ProgressRow'
import { ProgressContainer, ProgressBar, ValueText } from '../ProgressRow/styles'
import {
  NEUTRAL_COLOR,
  calculatePercentage,
  getProgressColor
} from '../common/utils'
import { formatPrice } from '../../../../../../utils/format'
import { formatDate } from './utils'
import { BootstrapTooltip } from 'components/BootstrapTooltip'
import { FUTURE_SALES_MESSAGE, isFieldDisabled } from 'utils/reportDisabledFields'
import { formatValue } from '../ProgressRow/utils'

export const DaySoldCard = ({
  disabledReason,
  daySoldValue = 0,
  dayGoalValue = 0
}: DaySoldCardProps) => {
  const disabled = isFieldDisabled(disabledReason)
  const percentage = disabled ? 0 : calculatePercentage(daySoldValue, dayGoalValue)
  const progressColor = disabled ? NEUTRAL_COLOR : getProgressColor(percentage)
  const formattedDate = formatDate(new Date())

  return (
    <DaySoldCardContainer>
      <CardTitle>{`VENDAS DO DIA - ${formattedDate}`}</CardTitle>

      <ValueWrapper>
        {disabled
          ? (
            <BootstrapTooltip title={FUTURE_SALES_MESSAGE}>
              <span>-</span>
            </BootstrapTooltip>
            )
          : formatPrice(daySoldValue)}
      </ValueWrapper>

      <StickyBottomWrapper>
        {disabled
          ? (
            <div>
              <ProgressContainer>
                <ValueText>{formatValue(dayGoalValue, 'currency')}</ValueText>
                <BootstrapTooltip title={FUTURE_SALES_MESSAGE}>
                  <ValueText color={progressColor}>-</ValueText>
                </BootstrapTooltip>
              </ProgressContainer>
              <ProgressBar progresscolor={progressColor} value={0} />
            </div>
            )
          : (
            <ProgressRow
              leftValue={dayGoalValue}
              leftFormat="currency"
              rightValue={percentage}
              rightFormat="percentage"
              rightColor={progressColor}
              progressValue={percentage}
              progressColor={progressColor}
            />
            )}
      </StickyBottomWrapper>
    </DaySoldCardContainer>
  )
}
